import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

// Azure "Virtual Machine" service icon (10021), redrawn as a white glyph on
// the codebase's 40×40 icon grid so it reads on every node background.
function createAzureInstanceIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <path d="M22.5851 25.9838H17.094C17.094 28.9463 17.0006 30.7782 14.2318 31.1789C13.8495 31.2178 13.4965 31.3856 13.2408 31.6499C12.9852 31.9142 12.845 32.2563 12.8473 32.6101H26.8473C26.8496 32.2563 26.7094 31.9142 26.4538 31.6499C26.1981 31.3856 25.8451 31.2178 25.4629 31.1789C22.694 30.7782 22.5851 28.9463 22.5851 25.9838Z" fill="white"/>
    <path d="M6.78066 8.81006H32.914C33.4294 8.81006 33.8473 9.19451 33.8473 9.66875V25.1252C33.8473 25.5994 33.4294 25.9838 32.914 25.9838H22.5851H17.094H6.78066C6.2652 25.9838 5.84733 25.5994 5.84733 25.1252V9.66875C5.84733 9.19451 6.2652 8.81006 6.78066 8.81006ZM24.7263 20.1894L24.9177 20.0846V14.6801L20.0581 12.0721L19.8621 11.9673L19.6662 12.0721L14.8066 14.6801V20.0846L14.998 20.1894L19.6646 22.7079L19.8621 22.8141L20.0596 22.7079L24.7263 20.1894ZM15.9656 19.8806L19.4732 21.7729V18.0092L15.9656 19.8806ZM20.251 21.7729L23.7571 19.8806L20.251 18.0092V21.7729ZM15.5844 19.2586L19.0768 17.3956L15.5844 15.5102V19.2586ZM20.646 17.3956L24.1399 19.2586V15.5102L20.646 17.3956ZM15.9656 14.8855L19.85 16.9819L23.7571 14.8855L19.8621 12.7947L15.9656 14.8855Z" fill="white"/>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const azureInstanceIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createAzureInstanceIcon,
);
